import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-9" }
const _hoisted_2 = { class: "card-title m-0" }
const _hoisted_3 = {
  key: 0,
  class: "symbol symbol-50px w-50px bg-light border border-success"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "symbol symbol-50px w-50px bg-light border border-info"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 2,
  class: "symbol symbol-50px w-50px bg-light border border-warning"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 3,
  class: "symbol symbol-50px w-50px bg-light border border-danger"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "card-toolbar" }
const _hoisted_12 = {
  key: 0,
  class: "badge badge-light-primary fw-bolder me-auto px-4 py-3"
}
const _hoisted_13 = {
  key: 1,
  class: "badge badge-light-success fw-bolder me-auto px-4 py-3"
}
const _hoisted_14 = {
  key: 2,
  class: "badge badge-light-warning fw-bolder me-auto px-4 py-3"
}
const _hoisted_15 = { class: "card-body p-9" }
const _hoisted_16 = { class: "fs-3 fw-bolder text-dark d-flex" }
const _hoisted_17 = { class: "dificulty mb-5 mt-3 d-flex" }
const _hoisted_18 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_19 = {
  key: 1,
  class: "badge badge-light-info"
}
const _hoisted_20 = {
  key: 2,
  class: "badge badge-light-warning"
}
const _hoisted_21 = {
  key: 3,
  class: "badge badge-light-danger"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 fw-bold fs-5 mt-1 mb-7" }, null, -1)
const _hoisted_23 = { class: "d-flex flex-wrap mb-5 justify-content-start" }
const _hoisted_24 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 mb-3" }
const _hoisted_25 = { class: "fs-6 text-gray-800 fw-bolder" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-gray-500" }, "XP earned", -1)
const _hoisted_27 = {
  class: "h-4px w-100 bg-light mb-5",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-bs-original-title": "This project 50% completed"
}
const _hoisted_28 = ["aria-valuenow"]
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = { class: "text-gray-600 fs-6" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-shield me-1" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, "Crowsec", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "symbol-group symbol-hover justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "symbol symbol-35px symbol-circle",
    "data-bs-toggle": "tooltip",
    title: "",
    "data-bs-original-title": "Emma Smith"
  })
], -1)

import type {MachineType} from "@/types/MachineType";
import {computed} from "vue";
import moment from "moment";
import {useRouter, useRoute} from "vue-router";
import {useStore} from "vuex";


export default /*#__PURE__*/_defineComponent({
  props: {
  machine:  {
    type: Object as () => MachineType,
  },
  certificationId: {
    type: String,
  }
},
  setup(__props) {

const props = __props

const store = useStore();
const router = useRouter();
const route = useRoute();
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: { name: 'certifications-machines-show', params: { id: props.machine?.id, certification_id: props.certificationId || _unref(route).params.id } },
    class: "card border-hover-primary",
    style: {"cursor":"pointer"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (props.machine?.dificulty == 'easy')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: props.machine.photo_path,
                  alt: "image",
                  class: "p-1"
                }, null, 8, _hoisted_4)
              ]))
            : _createCommentVNode("", true),
          (props.machine?.dificulty == 'medium')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: props.machine.photo_path,
                  alt: "image",
                  class: "p-1"
                }, null, 8, _hoisted_6)
              ]))
            : _createCommentVNode("", true),
          (props.machine?.dificulty == 'hard')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: props.machine.photo_path,
                  alt: "image",
                  class: "p-1"
                }, null, 8, _hoisted_8)
              ]))
            : _createCommentVNode("", true),
          (props.machine?.dificulty == 'insane')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("img", {
                  src: props.machine?.photo_path,
                  alt: "image",
                  class: "p-1"
                }, null, 8, _hoisted_10)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          (
                  props.machine?.percentage > 0 &&
                  props.machine?.percentage < 100
                )
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.user_progress.in_progress`)), 1))
            : _createCommentVNode("", true),
          (props.machine?.percentage == 100)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.user_progress.completed`)), 1))
            : _createCommentVNode("", true),
          (props.machine?.percentage == 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.user_progress.not_started_yet`)), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, _toDisplayString(props.machine.name), 1),
        _createElementVNode("div", _hoisted_17, [
          (props.machine?.dificulty == 'easy')
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.easy`)), 1))
            : _createCommentVNode("", true),
          (props.machine?.dificulty == 'medium')
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.medium`)), 1))
            : _createCommentVNode("", true),
          (props.machine?.dificulty == 'hard')
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.hard`)), 1))
            : _createCommentVNode("", true),
          (props.machine?.dificulty == 'insane')
            ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.insane`)), 1))
            : _createCommentVNode("", true)
        ]),
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, _toDisplayString(props.machine.xp), 1),
            _hoisted_26
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", {
            class: "bg-primary rounded h-4px",
            role: "progressbar",
            style: _normalizeStyle('width: ' + props.machine?.percentage + '%'),
            "aria-valuenow": props.machine?.percentage,
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }, null, 12, _hoisted_28)
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("small", _hoisted_31, [
              _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.creator`)) + ": ", 1),
              _hoisted_32,
              _hoisted_33
            ]),
            _hoisted_34
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})